/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NavigationEnd, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class UserManagementApiService {
  private history = [];
  public img = '';
  previousUrl;
  private APIService = environment.serviceUrl;

  constructor(
    private http: HttpClient,
    public snackBar: MatSnackBar,
    private router: Router
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.history.push(event.urlAfterRedirects);
      }
    });
  }

  createUser(Payload): Observable<any> {
    return this.http.post(this.APIService + 'users/createUser', Payload);
  }

  //Fetch user single data  /user/userdetails?id=
  getSingleUser(id): Observable<any> {
    return this.http.get(this.APIService + 'users/getUserdetails?id=' + id);
  }
  //Update user  user/customerDetailsUpdate user/userdetailsupdate
  updateUser(Payload): Observable<any> {
    return this.http.put(this.APIService + 'users/updateUserdetails', Payload);
  }

  getAllUser(
    currentPage,
    pageSize,
    roleId,
    search,
    userRefId
  ): Observable<any> {
    return this.http.get(
      this.APIService +
        'users/getUsersList?page=' +
        currentPage +
        '&size=' +
        pageSize +
        '&roleId=' +
        roleId +
        '&search=' +
        search +
        '&userRefId=' +
        userRefId
    );
  }

  deleteUser(Sid): Observable<any> {
    return this.http.delete(`${this.APIService}users/delete/${Sid}`);
  }

  userChangePassword(Payload): Observable<any> {
    return this.http.put(this.APIService + 'users/changepassword', Payload);
  }

  getMangerDetails(): Observable<any> {
    return this.http.get(this.APIService + 'users/getMangerDetails');
  }
}
